<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="visit-point-create-tab-info">
		<vs-row vs-w="12">
			<vs-col
				:vs-lg="windowWidth < 1366 ? '12' : '5'"
				:vs-sm="windowWidth < 1366 ? '12' : '5'"
				vs-xs="12"
				class="pr-2"
			>
				<vx-card v-show="windowWidth > 1280 || maximize">
					<template slot="actions">
						<feather-icon
							v-show="maximize && windowWidth < 1280"
							icon="XSquareIcon"
							svgClasses="h-5 w-5"
							class="hover:text-success"
							@click.stop="maximize = !maximize"
						/>
					</template>
					<div class="vx-row">
						<div class="vx-col md:w-1/2 w-full">
							<label class="g-label" v-text="$t('MapModule.Latitude')"></label>
							<vs-input class="w-full mb-4" v-model="visitPoint.cy" name="cy" disabled />
							<span
								class="text-danger text-sm"
								v-show="errors.has('cy')"
								v-text="errors.first('cy')"
							></span>
						</div>
						<div class="vx-col md:w-1/2 w-full">
							<label class="g-label" v-text="$t('MapModule.Longitude')"></label>
							<vs-input class="w-full mb-4" v-model="visitPoint.cx" name="cx" disabled />
							<span
								class="text-danger text-sm"
								v-show="errors.has('cx')"
								v-text="errors.first('cx')"
							></span>
						</div>
					</div>
					<div class="map-custom-container">
						<here-map
							name="theMap"
							ref="moduleMap"
							latitude="4.686699"
							longitude="-74.0837187"
							zoom="13"
							:width="widthMap"
							height="90vh"
							theme="uber"
							calledFrom="calendar"
							@geoInversoEmit="geoInverso"
						></here-map>
					</div>
				</vx-card>
			</vs-col>
			<vs-col
				class="pr-2"
				vs-justify="center"
				vs-align="center"
				:vs-lg="windowWidth < 1366 ? '12' : '7'"
				:vs-sm="windowWidth < 1366 ? '12' : '7'"
				vs-xs="12"
			>
				<vx-card v-show="windowWidth > 1280 || !maximize" style="height: 100%">
					<template slot="actions">
						<feather-icon
							v-show="windowWidth <= 1280"
							icon="MapIcon"
							svgClasses="h-5 w-5"
							class="hover:text-success"
							@click.stop="maximize = !maximize"
						/>
					</template>
					<vs-navbar :type="'gradient'" v-model="activeNavItem" class="nabarx mb-5">
						<div slot="title">
							<vs-navbar-title>
								<span class="g-tools--description">{{ navbarTitle }}</span>
							</vs-navbar-title>
						</div>
						<vs-navbar-item :index="0">
							<a>
								<div class="flex flex-col items-center justify-center">
									<vx-tooltip
										style="z-index: 99999"
										:title="$t('Information')"
										color="primary"
										position="bottom"
										:text="`${$t('Information')}: ${$t('Resource.PrincipalProperties')}, ${$t(
											'Resource.AdditionalProperties'
										)}`"
									>
										<vs-icon icon="info" size="medium" class="cursor-pointer"></vs-icon>
									</vx-tooltip>
									<small>{{ $t("Information") }}</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-navbar-item :index="1" v-if="visitpointRelationship !== 'all'">
							<a>
								<div class="flex flex-col items-center justify-center">
									<vs-icon icon="person" size="medium" class="cursor-pointer"></vs-icon>

									<small>{{ $t("Resource.AssigResources") }}</small>
								</div>
							</a>
						</vs-navbar-item>
						<vs-spacer></vs-spacer>
					</vs-navbar>
					<!-- SELECTION OF TIPOLOGIA -->
					<transition name="fade">
						<div v-show="activeNavItem === 0">
							<div class="vx-row">
								<div class="vx-col w-full">
									<label class="g-label">{{ $t("ObjectType") }}</label>
									<v-select
										v-if="categoryOptions"
										name="typology"
										v-model="selectedT"
										v-validate="'required'"
										:placeholder="$t('Select')"
										:clearable="false"
										:options="categoryOptions"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
									>
										<template v-slot:no-options="{search, searching}">
											<template v-if="searching">
												{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
											</template>
										</template>
									</v-select>
									<span
										class="text-danger text-sm"
										v-show="errors.has('role')"
										v-text="errors.first('role')"
									></span>
								</div>
							</div>
							<form v-if="selectedT">
								<!-- STATICS FIELDS -->
								<!-- ROW ONE -->
								<div class="vx-row mt-4">
									<!--NAME -->
									<div class="vx-col md:w-1/2 w-full">
										<label class="g-label" v-text="$t('Name')"></label>
										<vs-input
											class="w-full"
											v-model="visitPoint.name"
											v-validate="'required'"
											name="name"
											:danger="dangerInput.name.show"
											:danger-text="dangerInput.name.text"
											@focus="() => (dangerInput.name.show = false)"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('name')"
											v-text="$t('VisitPointObject.Create.ValidMessages.Name')"
										></span>
									</div>
									<!--IDENTIFICATION -->
									<div class="vx-col md:w-1/2 w-full">
										<label class="g-label" v-text="$t('Identification')"></label>
										<vs-input
											class="w-full"
											v-model="visitPoint.identification"
											type="identification"
											v-validate="'required|alpha_num'"
											name="identification"
											:danger="dangerInput.identification.show"
											:danger-text="dangerInput.identification.text"
											@focus="() => (dangerInput.identification.show = false)"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('identification')"
											v-text="$t('VisitPointObject.Create.ValidMessages.Identification')"
										></span>
									</div>
								</div>
								<!-- ROW TWO -->
								<div class="vx-row mt-4">
									<div class="vx-col md:w-1/2 w-full">
										<!-- PHONE -->
										<label class="g-label" v-text="$t('Phone')"></label>
										<vs-input
											class="w-full"
											v-model="visitPoint.phone"
											v-validate="'required'"
											name="phone"
											:danger="dangerInput.phone.show"
											:danger-text="dangerInput.phone.text"
											@focus="() => (dangerInput.phone.show = false)"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('phone')"
											v-text="$t('VisitPointObject.Create.ValidMessages.Phone')"
										></span>
									</div>
									<!-- address -->
									<div class="vx-col md:w-1/2 w-full">
										<!--ADDRESS -->
										<label class="g-label" v-text="$t('Address')"></label>
										<vs-input
											class="w-full"
											v-model="visitPoint.address"
											v-validate="'required'"
											name="address"
											:danger="dangerInput.address.show"
											:danger-text="dangerInput.address.text"
											@focus="() => (dangerInput.address.show = false)"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('address')"
											v-text="$t('VisitPointObject.Create.ValidMessages.Address')"
										></span>
									</div>
								</div>
								<div class="vx-row mt-4">
									<!-- COUNTRY -->
									<div class="vx-col md:w-1/2 w-full">
										<label class="g-label" v-text="$t('Country')"></label>
										<v-select
											v-model="selectedCountry"
											v-validate="'required'"
											name="country"
											:placeholder="$t('Select')"
											:clearable="false"
											:options="countriesOptions"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:disabled="
												visitPoint.address === '' ||
												visitPoint.address === null ||
												visitPoint.address === undefined
											"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
										<span
											class="text-danger text-sm"
											v-show="errors.has('country')"
											v-text="$t('VisitPointObject.Create.ValidMessages.Country')"
										></span>
									</div>
									<div class="vx-col md:w-1/2 w-full">
										<!--Department -->
										<label class="g-label">{{ getPoliticalDivision.department }}</label>
										<v-select
											v-model="selectedDepartment"
											v-validate="'required'"
											name="departments"
											:placeholder="$t('Select')"
											:clearable="false"
											:options="departments"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:loading="
												departments.length <= 0 && selectedCountry.value != '' ? true : false
											"
											:disabled="
												departments.length <= 0 ||
												visitPoint.address === '' ||
												visitPoint.address === null ||
												visitPoint.address === undefined
											"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
										<span class="text-danger text-sm" v-show="errors.has('departments')">{{
											$t("ValidateField", {n: getPoliticalDivision.department.toLowerCase()})
										}}</span>
									</div>
								</div>
								<!-- ROW THREE -->
								<div class="vx-row mt-4 mb-4">
									<div class="vx-col md:w-1/2 w-full">
										<!--CITY -->
										<label class="g-label">{{ getPoliticalDivision.city }}</label>
										<v-select
											v-model="selectedCity"
											v-validate="'required'"
											name="cities"
											:placeholder="$t('Select')"
											:clearable="false"
											:options="cities"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:loading="
												cities.length <= 0 && selectedDepartment && selectedCountry.value != ''
													? true
													: false
											"
											:disabled="
												cities.length <= 0 ||
												visitPoint.address === '' ||
												visitPoint.address === null ||
												visitPoint.address === undefined
											"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
										<span class="text-danger text-sm" v-show="errors.has('cities')">{{
											$t("ValidateField", {n: getPoliticalDivision.city.toLowerCase()})
										}}</span>
									</div>
									<div class="vx-col md:w-1/2 w-full mt-5 text-center">
										<vs-button v-if="showGeoAgaing" type="border" color="success" @click="geoCoder"
											>{{ $t("MapModule.GeoAgain") }}
										</vs-button>
									</div>
								</div>
								<!-- DINAMIC FIELDS -->
								<div v-if="dinamicFields">
									<vs-divider></vs-divider>
									<p class="g-object--description mb-2">
										{{ $t("Object.AdditionalFields") }}
									</p>
									<dinamic-fields
										ref="DinamicFields"
										:additionalFields="dinamicFields"
										:additionalInfo="additional_info"
										:category="selectedT.category"
									></dinamic-fields>
								</div>
							</form>
							<p v-else class="g-label--normal mb-2 mt-4">
								{{ $t("VisitPointObject.Create.LabelInfoObjectType") }}
							</p>
						</div>
					</transition>
					<transition name="fade">
						<vs-row vs-w="12" v-show="activeNavItem === 1">
							<vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
								<resource-list
									class="mt-4"
									:relatedIds="relatedIds"
									:customConfig="{activeCheckbox: false}"
								></resource-list>
							</vs-col>
						</vs-row>
					</transition>
				</vx-card>
			</vs-col>
		</vs-row>
		<vs-row>
			<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
				<!-- Save & Reset Button  :disabled="!validateForm"-->
				<div class="vx-row mt-4 items-center justify-end">
					<vs-button
						class="mr-1"
						type="filled"
						color="danger"
						:class="windowWidth <= 260 ? 'w-full mb-2' : ''"
						@click.prevent="$router.push(`/apps/visit-point/visit-point-list`)"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						id="btn-save-visit-point"
						class="ml-1 vs-con-loading__container"
						:disabled="!validateForm"
						:class="windowWidth <= 260 ? 'w-full' : ''"
						@click.prevent="submitForm"
						>{{ $t("Save") }}
					</vs-button>
				</div>
			</vs-col>
		</vs-row>
		<vs-prompt title="" :active.sync="activePrompt" @cancel="close" @accept="acceptAlert" @close="close">
			<div class="con-exemple-prompt">
				<p>
					{{ $t("VisitPointObject.Create.GeoFindNextAddress") }}
				</p>
				<vs-input
					placeholder="Code"
					vs-placeholder="Code"
					v-model="dataGeo.address1"
					class="mt-3 w-full mb-4"
				/>
				<p>{{ $t("VisitPointObject.Create.UseAddressQuestion") }}</p>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import vSelect from "vue-select";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import VisitPoint from "@/models/VisitPoint.js";
import moduleManualData from "@/store/manual-data/moduleManualData.js";
import HereMap from "@/components/Maps/Maps.vue";
import Commons from "@/helpers/commons.js";
import ResourceList from "@/components/resource/resource-assigned-list/ResourceList.vue";
import {clearMap} from "../../../utils/HereMap";
import PopupCustomize from "@/core/components/PopupCustomize";
import DinamicFields from "@/components/DinamicFields/DinamicFields";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import {politicalDivisionMixin} from "@/mixins/politicalDivisionMixin.js";

export default {
	mixins: [politicalDivisionMixin],
	components: {
		DinamicFields,
		PopupCustomize,
		vSelect,
		HereMap,
		ResourceList,
	},
	props: {
		visit_point: {
			type: Object,
			default: () => new VisitPoint({}),
		},
		manual_data_id: {
			type: Number,
			default: 0,
		},
		upload_file_id: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			visitPoint: this.visit_point,
			model: null,
			dinamicFields: [],
			dataSelect: null,
			selectedT: null,
			departments: [],
			countries: [],
			cities: [],
			additional_info: {},
			dangerInput: {
				name: {show: false, text: ""},
				identification: {show: false, text: ""},
				address: {show: false, text: ""},
				city: {show: false, text: ""},
				country: {show: false, text: ""},
				phone: {show: false, text: ""},
			},
			dataGeo: {
				dirtrad: "",
				estado: "",
				latitude: "",
				longitude: "",
			},
			activePrompt: false,
			showGeoAgaing: false,
			relatedIds: [],
			manageErrorMessages: new ManageErrorMessages({that: this}),
			activeNavItem: 0,
			maximize: false,
		};
	},
	computed: {
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Information");
			else return this.$t("Resource.AssigResources");
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		widthMap() {
			let widthValue = "";
			if (this.windowWidth >= 1366 && this.windowWidth < 1920) {
				widthValue = "100%";
			} else if (this.windowWidth >= 600 && this.windowWidth < 1366) {
				widthValue = "100%";
			} else if (this.$store.state.reduceButton && this.windowWidth > 600) {
				widthValue = "33vw";
			} else if (this.windowWidth > 600) {
				widthValue = "27vw";
			} else if (this.windowWidth < 600) {
				widthValue = "100%";
			}
			return widthValue;
		},
		categoryOptions() {
			if (this.dataSelect === undefined || this.dataSelect === null) return;
			const {category} = this.dataSelect;
			return category.map((category) => {
				return {
					label: category.typology_name,
					value: category.typology_id,
					category,
				};
			});
		},
		countriesOptions() {
			return this.generateOptionSelect(
				this.$store.state.moduleCommon.countries_sitidata,
				"country_name",
				"country_name"
			);
		},
		validateForm() {
			return !this.errors.any();
		},
		visitpointRelationship() {
			const visitpointConfig = this.$store.getters["moduleCompanyConfig/visitpointConfig"];
			if (visitpointConfig) {
				return visitpointConfig.config_json.relationship;
			} else {
				return "all";
			}
		},
		selectedCountry: {
			get() {
				return {
					label: this.visitPoint.country === undefined ? "" : this.visitPoint.country,
					value: this.visitPoint.country === undefined ? "" : this.visitPoint.country,
				};
			},
			set(obj) {
				this.selectedDepartment = {};
				this.selectedCity = {};
				this.visitPoint.country = obj.label;
				this.getDepartments(obj.label);
			},
		},
		selectedDepartment: {
			get() {
				return {
					label: this.visitPoint.department,
					value: this.visitPoint.department,
				};
			},
			set(obj) {
				this.selectedCity = {};
				this.visitPoint.department = obj.label;
				this.getCities(obj.label);
			},
		},
		selectedCity: {
			get() {
				return {
					label: this.visitPoint.city,
					value: this.visitPoint.city,
				};
			},
			set(obj) {
				if (Object.entries(obj).length > 0) {
					this.visitPoint.city = obj.label;
					this.geoCoder();
				}
			},
		},
	},
	methods: {
		valueCreatePointEmit(val) {
			this.activeNavItem = val;
			if (this.selectedCity) {
				this.geoCoder();
			}
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		submitForm() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.save_changes();
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("Schedule.ValidData.Title"),
						text: this.$t("Object.ErrorFields.Text"),
						time: 6000,
					});
					this.activeNavItem = 0;
				}
			});
		},
		fetchDataSelect() {
			const payload = {
				role: [],
				status: [],
				category: "VISIT_POINT",
				typology: [],
			};
			this.$store
				.dispatch("moduleResource/fetchDataSelect", payload, {
					module: "CreateTab",
				})
				.then((res) => {
					this.dataSelect = res.data;
					if (this.visitPoint.typology_id > 0 && this.manual_data_id > 0) {
						this.selectedT = {
							value: this.visitPoint.typology_id,
							label: this.visitPoint.typology_name,
						};
						this.selectedCountry = {
							label: this.visitPoint.country,
							value: this.visitPoint.country,
						};
						this.selectedCity = {
							label: this.visitPoint.city,
							value: this.visitPoint.city,
						};
					} else {
						this.selectedT = this.$store.state.moduleVisitPoint.selectedCategory
							? this.$store.state.moduleVisitPoint.selectedCategory
							: null;
					}
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		capitalize(str = "") {
			return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
		},
		save_changes() {
			if (!this.validateForm) return;
			if (this.manual_data_id > 0) {
				this.fixeManualData();
			} else {
				if (
					this.$store.state.moduleResource.resourcesActivity.length > 0 ||
					this.visitpointRelationship === "all"
				) {
					this.registerVisitPoint();
				} else {
					this.confirmCreateWithoutResource();
				}
			}
		},
		registerVisitPoint() {
			delete this.visitPoint.status_id;
			delete this.visitPoint.id;
			const ids = this.$store.state.moduleResource.resourcesActivity.map(({id}) => id);
			this.visitPoint["resource_id"] = ids || [];
			// recuperamos todas las propiedades adicionales modificadas desde el componente hijo
			if (this.$refs.DinamicFields !== undefined) {
				const additional_info = this.$refs.DinamicFields.getAddionalInfo();
				Object.assign(this.visitPoint.additional_info, additional_info);
			}
			Commons.openLoadingButton.call(this, "btn-save-visit-point");
			this.$store
				.dispatch("moduleVisitPoint/addVisitPoint", this.visitPoint)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("VisitPointObject.Create.Success.Title"),
						text: this.$t("VisitPointObject.Create.Success.Text"),
					});
					this.visitPoint = new VisitPoint({});
					Commons.closeLoadingButton.call(this, "btn-save-visit-point");
					this.$router.push({name: "app-visit-point-list"});
				})
				.catch((error) => {
					Commons.closeLoadingButton.call(this, "btn-save-visit-point");
					this.manageErrorAlert(error);
				});
		},
		manageErrorAlert(err) {
			const {title, text} = Commons.manageErrorValidator.call(this, err);
			const findErrorNameProperty = Commons.findErrorNamePropertyValidator();
			const nameProperty = findErrorNameProperty(err);
			const alert_message = `${this.$t("ManualData.PropertyError")} ${nameProperty}: ${
				text ? text : this.$t("ManualData.ValidatorRequiredProperty")
			}`;
			this.$vs.notify({
				color: "danger",
				title,
				text: alert_message,
				time: 6000,
			});
		},
		fixeManualData() {
			// Clean properties not spected or allowed
			delete this.visitPoint.status_id;
			delete this.visitPoint.id;
			delete this.visitPoint.additional_info;
			delete this.visitPoint.category_id;
			delete this.visitPoint.typology_id;
			delete this.visitPoint.typology_name;

			Object.assign(this.visitPoint, {...this.additional_info});
			Commons.openLoadingButton.call(this, "btn-save-visit-point");
			this.$store
				.dispatch("moduleManualData/updateManualdataVisitpoint", {
					visit_point: this.visitPoint,
					manual_data_id: this.manual_data_id,
				})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("VisitPointObject.Create.Success.Title"),
						text: this.$t("VisitPointObject.Create.Success.Text"),
					});

					Commons.closeLoadingButton.call(this, "btn-save-visit-point");

					this.$router
						.push({
							name: `app-manual-data`,
							params: {id: this.upload_file_id},
						})
						.catch(() => {});
				})
				.catch((error) => {
					Commons.closeLoadingButton.call(this, "btn-save-visit-point");
					this.manageErrorAlert(error);
				});
		},
		getCities(departmentName) {
			this.$store
				.dispatch("moduleCommon/getCitiesByDeparment", {
					name: departmentName,
					country: this.visitPoint.country,
				})
				.then((res) => {
					this.cities = this.generateOptionSelect(res.data, "city_name", "city_name");
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		getDepartments(countryName) {
			this.$store
				.dispatch("moduleCommon/getDepartments", {name: countryName})
				.then((res) => {
					this.departments = this.generateOptionSelect(res.data, "department_name", "department_name");
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		enableDangerInput(error) {
			const propertie = error.data.absolute_path[0];
			if (propertie === "additional_info") {
				this.dangerInput[data.absolute_path[1]].show = true;
				this.dangerInput[data.absolute_path[1]].text = data.message;
				return;
			}
			error.data.reason.forEach(({absolute_path, message}) => {
				this.dangerInput[absolute_path].show = true;
				this.dangerInput[absolute_path].text = message;
			});
		},
		reset_data() {
			this.visitPoint = new VisitPoint({});
			this.selectedDepartment = null;
			this.selectedCity = null;
			this.showGeoAgaing = false;
			setTimeout(() => {
				this.errors.clear();
			}, 200);
			this.$store.dispatch("moduleResource/cleanResourceActivity");
		},
		compare_input_date(inputName) {
			let result = inputName.match(/date|fecha|color/g);
			return result || [];
		},
		/** generate data for any select */
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		setDataModelDinamicFields(tipologyId) {
			if (!tipologyId) {
				return;
			}
			const found = this.dataSelect.typology.find((typology) => typology.typology_id === tipologyId);
			this.dinamicFields = this.visitPoint.dataModelDinamicFields(found);
			// Agregar campos dinamicos al objeto danger para el renderizado
			if (this.dinamicFields.length > 0) {
				this.dinamicFields.forEach((m) => {
					this.dangerInput[m.name] = {
						show: false,
						text: "nada",
					};
				});
			}
		},
		geoInverso({country, cy, cx}) {
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {country, cy, cx})
				.then((res) => {
					this.closeLoading();
					this.dataGeo = {...res.data};
					this.dataGeo.longitude = parseFloat(cx);
					this.dataGeo.latitude = parseFloat(cy);
					if (res.data.address1 !== this.visitPoint.address) {
						this.activePrompt = true;
					}
					if (res.status === 200 && res.data.status === "C") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPointObject.Create.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPointObject.Create.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		geoCoder() {
			const {country, city, address, department} = this.visitPoint;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPointObject.Create.MissingAddress.Title"),
					text: this.$t("VisitPointObject.Create.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();

					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}

					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("MapModule.Georeferencer"),
							text: this.$t("ManualData.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}

					if (res.status === 200 && res.message === "Geocodificacion Exitosa.") {
						clearMap();
						this.dataGeo = {...res.data};
						this.visitPoint.cy = parseFloat(this.dataGeo.latitude).toFixed(8);
						this.visitPoint.cx = parseFloat(this.dataGeo.longitude).toFixed(8);
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							this.$vs.notify({
								color: "success",
								title: this.$t("VisitPointObject.Create.FindAddress.Title"),
								text: this.$t("VisitPointObject.Create.FindAddress.Text"),
							});
							this.showGeoAgaing = true;
							this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint);
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
								text: this.$t("VisitPointObject.Create.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		openConfirmDirection(res) {
			this.$vs.dialog({
				type: "confirm",
				color: "success",
				title: "",
				text: this.$t("VisitPointObject.Create.GeoRefFindAddress") + ` ${res.data.address1}`,
				accept: this.acceptAlert,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		acceptAlert() {
			this.selectedCountry.label = this.dataGeo.country_long_name;
			this.visitPoint.country = this.dataGeo.country_long_name;
			this.visitPoint.address = this.dataGeo.address1;
			this.selectedDepartment.label = this.dataGeo.department1;
			this.selectedCity.label = this.dataGeo.city1;
			this.visitPoint.department = this.dataGeo.department1;
			this.visitPoint.city = this.dataGeo.city1;
			this.visitPoint.cx = this.dataGeo.longitude.toFixed(8);
			this.visitPoint.cy = this.dataGeo.latitude.toFixed(8);
		},
		close() {
			this.dataGeo.address1 = "";
			this.geoCoder();
		},
		confirmCreateWithoutResource() {
			this.$vs.dialog({
				type: "confirm",
				color: "primary",
				title: this.$t("Confirm"),
				text: this.$t("VisitPointObject.Create.WithoutResource"),
				accept: this.registerVisitPoint,
				acceptText: this.$t("Crud.Create"),
				cancelText: this.$t("Cancel"),
			});
		},
	},
	filters: {
		capitalizeFilter: function (value) {
			if (!value) return "";
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	watch: {
		selectedT(obj) {
			// Setear modelo de datos para renderizar campos dinamicos
			this.visitPoint.additional_info = {};
			this.setDataModelDinamicFields(obj.value);
			this.$store.commit("moduleVisitPoint/SET_SELECTED_CATEGORY", obj);
		},
	},
	created() {
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		if (!moduleManualData.isRegistered) {
			this.$store.registerModule("moduleManualData", moduleManualData);
			moduleManualData.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries_sitidata.length <= 0) {
			this.$store
				.dispatch("moduleCommon/getCountriesByTokenSitiData")
				.then((res) => {
					if (res.data.length === 1) {
						this.selectedCountry = {
							label: res.data[0]["country_name"].toUpperCase(),
							value: res.data[0]["country_name"].toUpperCase(),
						};
					}
				})
				.catch((error) => {
					throw new Error(error);
				});
		}
	},
	mounted() {
		this.fetchDataSelect();
	},
};
</script>
<style lang="scss" scoped>
#visit-point-create-tab-info {
	min-height: 80vh;
}

.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
